export default "__VITE_ASSET__896e780c__"